//
//
//

import empty from '../empty.vue';
export default {
  name: 'promotion',
  components: {
    empty: empty
  }
};